﻿
export class GeminiUtilities {
    static Tools(tools: any) {
        if (!tools) return [];
        return [{
            functionDeclarations: JSON.parse(tools).map((t: { name: any; description: any; parameters: any; }) => ({
                name: t.name,
                description: t.description,
                parameters: t.parameters,
            }))
        }];
    }
}
